/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTAwcHgiIGhlaWdodD0iNTBweCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsPSJub25lIiBkPSJNMCwyNSBMOTUsMjUgOTAsMjAgTTk1LDI1IEw5MCwzMCIgc3Ryb2tlPSIjMDAwIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+PC9zdmc+";